// components/TeammateTableHeader.jsx - Table Header Component
import React from 'react';

const TeammateTableHeader = ({ translate }) => {
  return (
    <div className='teammate-table-header'>
      <div className='header-cell'>#</div>
      <div className='header-cell'>{translate('action')}</div>
      <div className='header-cell'>{translate('items')}</div>
      <div className='header-cell'>{translate('weight') + '(' + translate('weight-unit') + ')'}</div>
      <div className='header-cell'>{translate('kasr_sakht')}</div>
      <div className='header-cell'>{translate('make_pay')}</div>
      <div className='header-cell'>{translate('stone-price')}</div>
      <div className='header-cell'>{translate('discount')}</div>
    </div>
  );
};

export default TeammateTableHeader;
